// URL-safe slug derivation. Output matches the regex enforced by
// every B.1 *Create endpoint: ^[a-z0-9][a-z0-9-]{0,62}$.
//
// Rules, in order:
//   1. Normalise Unicode → strip diacritics ("Khán" → "khan").
//   2. Lowercase.
//   3. Replace any run of non-alphanumeric with a single hyphen.
//   4. Trim leading + trailing hyphens (regex also forbids leading
//      hyphen).
//   5. Cap at 63 chars (regex upper bound is 63 incl. the first).
//
// Returns "" if nothing usable survives. Callers should not submit
// an empty slug.

const NON_ALNUM = /[^a-z0-9]+/g;
// Unicode combining diacriticals block (U+0300–U+036F).
const COMBINING_MARKS = /[̀-ͯ]/g;

export function slugify(input: string): string {
  if (!input) return "";
  return input
    .normalize("NFKD")
    .replace(COMBINING_MARKS, "")
    .toLowerCase()
    .replace(NON_ALNUM, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 63);
}
